<template>
    <h1 class="wizard-title">{{ user.isProf ? copydeck.titreIntroProfilProfs : copydeck.titreIntroProfil }}</h1>


    <div class="col-3 edit-sections">
        <div class="flex-col edit-section user-info">

            <div class="title-row">
                <h2 class="edit-section-title"> {{
                        user.isProf ? copydeck.title_tes_infosProfs :
                            copydeck.title_tes_infos
                    }}</h2>
                <button @click="modify('info')" v-if="!isUserAuthor()" class="btn btn-edit"><span class="sr-only">{{
                        copydeck.btn_modifier
                    }}</span></button>
            </div>


            <div class="fact" v-if=" user.name !== '' ">
                <div class="sr-only fact-label">{{ copydeck.factLabelUsername }}</div>
                <div class="fact-value username">{{ user.name }}</div>
            </div>

            <preview-avatar-profs v-if="isUserProf()"></preview-avatar-profs>

            <div class="fact birthday-row" v-if=" !user.isProf && strBirthday !== '' ">
                <div class="sr-only fact-label">{{ copydeck.factLabelBirthday }}</div>
                <div class="fact-value"><img :src=" iconBirthdaySrc "> {{ strBirthday }}</div>
            </div>
            <div class="fact" v-if="!isUserAuthor() && !user.isProf && phoneNumber !== '' ">
                <div class="sr-only fact-label">{{ copydeck.factLabelMobilePhone }}</div>
                <div class="fact-value"> {{ phoneNumber }}</div>
            </div>
            <div class="fact" v-if="!isUserAuthor() &&  email !== '' ">
                <div class="sr-only fact-label">{{
                        user.isProf ? copydeck.factLabelEmailProfs : copydeck.factLabelEmail
                    }}
                </div>
                <div class="fact-value"> {{ email }}</div>
            </div>


            <div class="fact" v-if="!isUserAuthor() &&  !user.isProf && getLabelValue('citoyennete') !== '' ">
                <div class="fact-label">{{ copydeck.factLabelCitizenship }}</div>
                <div class="fact-value"> {{ getLabelValue( "citoyennete" ) }}</div>
            </div>


            <div class="fact" v-if="!isUserAuthor() && user.isProf &&  user.profile.residence !== '' ">
                <div class="fact-value residence">{{ residenceLookedUp }}</div>
            </div>

            <div class="fact" v-if="!isUserAuthor() && user.isProf &&  user.profile['code-postal'] !== '' ">
                <div class="fact-value postal-code">{{ user.profile[ 'code-postal' ] }}</div>
            </div>


            <div class="fact" v-if="!isUserAuthor() && user.isProf &&  user?.profile?.programme?.length > 0 ">
                <div class="fact-label">{{
                        user.isProf ? copydeck.factLabelProgrammeProfs : copydeck.factLabelProgramme
                    }}
                </div>
                <div class="fact-value programmes" v-html=" programmesLookedUp "></div>
            </div>

            <div class="fact"
                 v-if="!isUserAuthor() && user.isProf &&  (user?.profile?.['age-eleves'] ?? '' ).length > 0 ">
                <div class="fact-label">{{
                        user.isProf ? copydeck.factLabelKidsTaughtProfs :
                            copydeck.factLabelKidsTaught
                    }}
                </div>
                <div class="fact-value postal-code" v-html=" ageElevesLookedUp "></div>
            </div>

            <div class="fact"
                 v-if="!isUserAuthor() && user.isProf &&  user?.profile?.['matiere-preferee-prof'] && user?.profile?.['matiere-preferee-prof'] !== '' ">
                <div class="fact-label">{{
                        user.isProf ? copydeck.factLabelMatierePrefereeProfs :
                            copydeck.factLabelMatierePreferee
                    }}
                </div>
                <div class="fact-value programmes" v-html=" getLabelValue( 'matiere-preferee-prof' ) "></div>
            </div>

            <div class="fact" v-if="!isUserAuthor() && hasPet">
                <div class="fact-label">{{ user.isProf ? copydeck.factLabelAnimalProfs : copydeck.factLabelAnimal }}
                </div>
                <div class="fact-value animals-container">
                        <span class="animal"
                              v-for="animal in animaux"
                        >
                            <span class="sr-only">{{ animal.name }}</span>
                            <span class="animal-emoji">{{ animal.emoji }}</span>
                        </span>
                </div>
            </div>
            <div class="fact" v-if="  !isAdult() && getLabelValue('matiere-preferee') !== '' ">
                <div class="fact-label">{{
                        user.isProf ? copydeck.factLabelSchoolSubjectProfs :
                            copydeck.factLabelSchoolSubject
                    }}
                </div>
                <div class="fact-value"> {{ getLabelValue( "matiere-preferee" ) }}</div>
            </div>

            <div class="fact" v-if=" !isAdult() && getLabelValue('passe-temps') !== '' ">
                <div class="fact-label">{{ user.isProf ? copydeck.factLabelHobbyProfs : copydeck.factLabelHobby }}</div>
                <div class="fact-value"> {{ getLabelValue( "passe-temps" ) }}</div>
            </div>

            <div class="fact" v-if="  !isAdult() && getLabelValue('sport') !== '' ">
                <div class="fact-label">{{ user.isProf ? copydeck.factLabelSportProfs : copydeck.factLabelSport }}</div>
                <div class="fact-value"> {{ getLabelValue( "sport" ) }}</div>
            </div>


            <div class="fact" v-if=" !isAdult() &&  getLabelValue('devise') !== '' ">
                <div class="fact-label">{{ user.isProf ? copydeck.factLabelMottoProfs : copydeck.factLabelMotto }}</div>
                <div class="fact-value is-quote">{{ !isUserProf() ? getLabelValue( "devise" ) : '' }}</div>
            </div>
            <div class="fact" v-if=" mascotteClean.trim() !== '' ">
                <div class="fact-label">{{
                        user.isProf ? copydeck.factLabelMascotteProfs : copydeck.factLabelMascotte
                    }}
                </div>
                <div class="fact-value">{{ mascotteClean }}</div>
            </div>
        </div>

        <div class="flex-col edit-section user-themes">

            <div v-if=" !isAdult() ">
                <div class="title-row">
                    <h2 class="edit-section-title"> {{ copydeck.title_tes_thematiques }}</h2>
                    <button @click="modify('interets')" class="btn btn-edit"><span class="sr-only">{{
                            copydeck.btn_modifier
                        }}</span></button>
                </div>

                <div class="themes-container">
                    <span v-for="theme in userThemes" :style="getStyle(theme)" class="theme-pill"> {{
                            theme.title
                        }} </span>

                    <div class="font_bigger" v-if="userThemes.length == 0">{{
                            copydeck.no_thematique_selected.fr
                        }}
                    </div>
                </div>
            </div>
        </div>

        <div class="flex-col edit-section user-notifications">
            <div class="subs notifications-section" v-if="! isAdult() ">
                <div class="title-row">
                    <h2 class="edit-section-title" v-html="      copydeck.sectionTitleTesNotifications.fr  "></h2>
                    <button @click="modify('interets')" class="btn btn-edit"><span class="sr-only">{{
                            copydeck.btn_modifier
                        }}</span></button>
                </div>

                <div class="txt-info" v-html="copydeck.info_subscribed_to_notification"></div>
                <ul class="notifications-list">
                    <li class="wanted-notification notification-theme" v-if="wantedThematicalNotification"
                        v-html="copydeck.subscribed_to_notification_thematique">
                    </li>
                    <li class="wanted-notification notification-contest" v-if="wantedContestNotification"
                        v-html="copydeck.subscribed_to_notification_concours">
                    </li>
                    <li class="wanted-notification notification-comment-reply" v-if="wantedCommentReplyNotification"
                        v-html="copydeck.subscribed_to_notification_reponse">
                    </li>
                    <li class="wanted-notification notification-message" v-if="wantedMessageNotification"
                        v-html="copydeck.subscribed_to_notification_message">
                    </li>
                    <li class="wanted-notification notification-none" v-if="!wantedAnyNotificationAtAll"
                        v-html="copydeck.not_subscribed_to_anything">
                    </li>

                    <li class="wanted-notification subscribed_newsletter" v-if="isNewsletterSub"
                        v-html="copydeck.subscribed_to_newsletter">
                    </li>

                    <li class="wanted-notification subscribed_newsletter" v-if="!isNewsletterSub"
                        v-html="copydeck.not_subscribed_to_newsletter">
                    </li>

                </ul>


            </div>


        </div>

        <div class="flex-col  edit-section user-avatar-section" v-if=" !isAdult() ">

            <div class="title-row">
                <h2 class="edit-section-title"> {{ copydeck.title_ton_avatar }}</h2>
                <button @click="modify('avatar')" class="btn btn-edit"><span class="sr-only">{{
                        copydeck.btn_modifier
                    }}</span></button>
            </div>

            <preview-avatar :smallOnly="false" v-if="!isAdult()"></preview-avatar>

        </div>
    </div>


</template>

<script>
export default {
    name : "Profile",
}
</script>

<script setup>

import {
    computed,
    onMounted,
}                         from "vue";
import { useStore }       from "vuex";
import useCopydeck        from "../composables/UseCopydeck";
import { sprintf }        from "../../components/composables/useData";
import PreviewAvatar      from "./PreviewAvatar.vue";
import PreviewAvatarProfs from "./PreviewAvatarProfs.vue";
import axios              from 'axios';
import {
    isUserProf,
    isAdult,
    isUserAuthor,
}                         from '../../Utils';


const iconBirthdaySrc = new URL( '../../../../images/icon-birthday.png', import.meta.url ).href;


let store    = useStore();
let copydeck = useCopydeck();
let emits    = defineEmits( [ "change-screen" ] );

const user    = computed( () => store.state.user );
const profile = computed( () => user.value.profile );

let dataStore = computed( () => store.state.datastore ?? {} );

const strBirthday = computed( () =>
{
    if (
        typeof profile.value[ "date-de-naissance-annee" ] === 'undefined'
        || typeof profile.value[ "date-de-naissance-mois" ] === 'undefined'
        || typeof profile.value[ "date-de-naissance-jour" ] === 'undefined'
        || profile.value[ "date-de-naissance-annee" ] === ''
        || profile.value[ "date-de-naissance-mois" ] === ''
        || profile.value[ "date-de-naissance-jour" ] === ''
    )
    {
        return copydeck.noBirthdayDateEntered.fr
    }


    return new Date(
        profile.value[ "date-de-naissance-annee" ],
        profile.value[ "date-de-naissance-mois" ],
        profile.value[ "date-de-naissance-jour" ],
    ).toLocaleDateString( "fr-CA", {
        month : 'long',
        day   : "numeric",
    } );
} );


const phoneNumber = computed( () => profile.value[ 'mobile-number' ] );
const email       = computed( () => user.value[ 'email' ] );


const hasPet = computed( () => (user?.value?.animaux ?? []).length > 0 );
let animaux  = computed( () => user?.value?.animaux ?? [] );

const userMascotte = computed( () =>
{
    if ( isUserProf() )
    {
        return '';
    }

    return sprintf( copydeck.prefix_mascotte.fr, getLabelValue( "mascotte-caracteristique" ), getLabelValue( "mascotte-animal" ), getLabelValue( "mascotte-qualite" ) )
} );

const mascotteClean = computed( () =>
{
    if ( isUserProf() )
    {
        return '';
    }

    return [ getLabelValue( "mascotte-caracteristique" ), getLabelValue( "mascotte-animal" ), getLabelValue( "mascotte-qualite" ) ].join( ' ' )
} );


const residenceLookedUp  = computed( () => isUserProf() ? getLabelValue( "residence" ) : '' );
const programmesLookedUp = computed( () =>
{

    if ( !isUserProf() )
    {
        return '';
    }

    const programmes = user?.value.profile?.programme ?? '';

    if ( programmes.length < 1 )
    {
        return '';
    }

    let prettyPrograms = getLabelValue( "programme" );
    return prettyPrograms.join( '<br>' );

} );

const ageElevesLookedUp = computed( () =>
{

    if ( !isUserProf() )
    {
        return '';
    }

    const agesEleves = user?.value.profile?.[ 'age-eleves' ] ?? '';

    if ( agesEleves.length < 1 )
    {
        return '';
    }

    let prettyAgesEleves = getLabelValue( "age-eleves" );

    return prettyAgesEleves.join( ', ' );

} );

const userThemes = computed( () =>
{

    if ( isUserProf() )
    {
        return '';
    }

    if ( (profile?.value?.thematiques?.length ?? 0) < 1 )
    {
        return [];
    }

    return store.getters.dataStoreThemes.filter( theme => profile.value.thematiques.includes( theme.slug ) );
} );

function modify ( group = "" )
{
    emits( "change-screen", "profile-wizard", { group } )
}

const subscribeToNewsletter = computed( () => parseInt( user.value.profile?.[ 'subscribe_to_newsletter' ] ?? "0" ) )
;
let isNewsletterSub         = computed( () =>
{

    return subscribeToNewsletter.value === 1;

    // return isUserProf()
    //     ? (user.profile?.[ 'subscribe-newsletter-prof' ] ?? false) === "subscribe-newsletter-prof-oui"
    //     : (user.profile?.[ 'subscribe-newsletter' ] ?? false) === "subscribe-newsletter-oui";
} );


let wantedThematicalNotification   = computed( () => !isUserProf() && parseInt( profile?.value?.[ 'notification_thematique' ] ?? 0 ) === 1 );
let wantedContestNotification      = computed( () => !isUserProf() && parseInt( profile?.value?.[ 'notification_concours' ] ?? 0 ) === 1 );
let wantedCommentReplyNotification = computed( () => !isUserProf() && parseInt( profile?.value?.[ 'notification_reponse' ] ?? 0 ) === 1 );
let wantedMessageNotification      = computed( () => !isUserProf() && parseInt( profile?.value?.[ 'notification_message' ] ?? 0 ) === 1 );

let wantedAnyNotificationAtAll = computed( () =>
{
    // console.log( 'wantedAnyNotificationAtAll',
    //     isUserProf(),
    //     profile?.value?.[ 'notification-thematique' ],
    //     profile?.value?.[ 'notification-concours' ],
    //     profile?.value?.[ 'notification-reponse' ],
    //     profile?.value?.[ 'notification-message' ],
    //     wantedThematicalNotification.value,
    //     wantedContestNotification.value,
    //     wantedCommentReplyNotification.value,
    //     wantedMessageNotification.value,
    //
    //     wantedThematicalNotification.value
    //     || wantedContestNotification.value
    //     || wantedCommentReplyNotification.value
    //     || wantedMessageNotification.value,
    // );

    return wantedThematicalNotification.value
        || wantedContestNotification.value
        || wantedCommentReplyNotification.value
        || wantedMessageNotification.value;

} );

function getStyle ( theme )
{
    return 'background-color: ' + theme.colour + ';';
}


function getLabelValue ( strType )
{
    let allFields = store.getters.allFields;

    let field      = allFields.find( f => f.key === strType )
    let profileKey = profile.value[ strType ] ?? "";


    if ( field && typeof field.value_list !== 'undefined' )
    {
        if ( Array.isArray( profileKey ) )
        {

            let foundValues = [];

            for ( let i = 0; i < profileKey.length; i++ )
            {
                const foundValue = field.value_list.find( v => v.value === profileKey[ i ] );

                if ( foundValue )
                {
                    foundValues.push( foundValue.label );
                }
            }

            return foundValues;


        } else
        {

            let valueFromList = field.value_list.find( v => v.value === profileKey );
            return valueFromList?.label ?? profileKey;
        }
    }

    console.error( '[Profile.vue] No field found or .value_list is empty.', strType, field, profileKey );

    return profileKey;
}


/**
 * There's a little intro block that the customer only
 * wants to show the first time they land on their profile.
 *
 * https://app.clickup.com/t/2uaaqqx
 *
 *
 * @returns {Promise<void>}
 */
async function maybeMarkProfilePageAsSeen ()
{

    if ( user.value.data.hasSeenProfilePage )
    {
        return;
    }

    try
    {
        let response = await axios.post( "/endpoints/user/mark-profile-as-seen", true );

    }
    catch (e)
    {

    }

}


async function mounted ()
{

    maybeMarkProfilePageAsSeen();

}


onMounted( mounted )
</script>


<style scoped lang="scss">


</style>
